/* -----------------Types--------------- */
import type { Confidence } from "@memorang/types";

import { useDemoExamStore } from "@hooks/useDemoExamStore";
import { Container } from "@memorang/ui";
/* -----------------Child components--------------- */
import useSessionStore from "../hooks/useSessionStore";
import BottomNavigationSession from "./BottomNavigationSession";
import ConfidenceSubmitButtons from "./ConfidenceSubmitButtons";
import NavButtons, { type NextButtonProps } from "./NavButtons";
import AIGenerateExplanationButton from "./SubmitAnswerAIFeedbackButton";

interface Props extends NextButtonProps {
	showConfidenceSubmitButtons?: boolean;
	onConfidenceProvided: (confidence: Confidence) => void;
	onAiFeedbackProvided: (confidence: Confidence) => void;
	progressText?: string;
	isSummativeTest?: boolean;
	toggleHelpDialog?: () => void;
	inReviewMode?: boolean;
	showSubmitAnswerAIFeedbackButton?: boolean;
	transcript?: string;
	handleTrackConfidenceClick: (confidence: Confidence) => void;
}
const StudySessionBottomAppBar = ({
	handleNext,
	handlePrevious,
	showConfidenceSubmitButtons,
	onConfidenceProvided,
	progressText,
	isSummativeTest,
	toggleHelpDialog,
	inReviewMode,
	showSubmitAnswerAIFeedbackButton,
	transcript,
	onAiFeedbackProvided,
	handleTrackConfidenceClick,
	...rest
}: Props) => {
	const isProethicaTest = useSessionStore(
		(state) => state.proethicaTestKind != null,
	);
	const isProethica =
		useDemoExamStore((state) => state.currentExam.id) === "proethica";
	const isProethicaContext = isProethicaTest || isProethica;
	return (
		<BottomNavigationSession isSummativeTest={isSummativeTest}>
			<Container
				fullWidth={isSummativeTest || isProethicaContext}
				maxWidth={isProethicaContext ? "none" : "sm"}
			>
				{showSubmitAnswerAIFeedbackButton ? (
					<AIGenerateExplanationButton
						onConfidenceProvided={onConfidenceProvided}
						onAiFeedbackProvided={onAiFeedbackProvided}
					/>
				) : showConfidenceSubmitButtons ? (
					<ConfidenceSubmitButtons
						onConfidenceProvided={onConfidenceProvided}
						handleTrackConfidenceClick={handleTrackConfidenceClick}
					/>
				) : (
					<NavButtons
						showButtonNavNext
						showButtonPrevious
						handleNext={handleNext}
						handlePrevious={handlePrevious}
						progressText={progressText}
						isSummativeTest={isSummativeTest}
						isProethicaTest={isProethicaTest}
						inReviewMode={inReviewMode}
						toggleHelpDialog={toggleHelpDialog}
						{...rest}
					/>
				)}
			</Container>
		</BottomNavigationSession>
	);
};

export default StudySessionBottomAppBar;
